import { render, staticRenderFns } from "./TransferTab62.vue?vue&type=template&id=a14f6e10"
import script from "./TransferTab62.vue?vue&type=script&lang=js"
export * from "./TransferTab62.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports